import React from 'react';
import { NavLink } from 'react-router-dom';
import './Navigation.css';

function Navigation() {
    return (
        <nav className="navigation">
            <div className="nav-brand">
                <span className="nav-couple">A & T</span>
            </div>
            <ul className="nav-links">
                <li>
                    <NavLink to="/" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
                        Home
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/info" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
                        General Info
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/schedule" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
                        Schedule
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/travel" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
                        Travel
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/rsvp" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
                        RSVP
                    </NavLink>
                </li>
            </ul>
        </nav>
    );
}

export default Navigation;
